var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFetImg4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 88,
    viewBox: "0 0 132 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.910156,
    width: 130.583,
    height: 87.9271,
    rx: 11.5157,
    fill: "#BDB2F7",
    fillOpacity: 0.16
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_362_872)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.9102 43.5C93.9102 46.2904 93.4949 48.9843 92.7215 51.5222C92.7215 51.5232 92.7215 51.5232 92.7205 51.5244C91.8383 54.4184 90.4827 57.1462 88.7088 59.5971V59.5981C86.2091 63.0541 82.9248 65.9063 79.1186 67.893C77.9917 68.4822 76.8248 68.9916 75.6266 69.4174C74.6431 69.7673 73.6402 70.0604 72.623 70.2951H72.6219C70.625 70.7565 68.5473 71 66.4102 71C61.9484 71 57.7358 69.9381 54.0105 68.0525C50.5275 66.2902 47.47 63.8084 45.0354 60.8026C42.8219 58.0727 41.1225 54.9108 40.0808 51.4626C39.3199 48.9427 38.9102 46.2691 38.9102 43.5C38.9102 28.3122 51.2223 16 66.4102 16C81.598 16 93.9102 28.3122 93.9102 43.5Z",
    fill: "#264D6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.8838 28.0082V41.5742C78.8838 44.7675 76.2955 47.3559 73.102 47.3559H59.205C55.1877 47.3559 51.9316 50.6133 51.9316 54.6305V61.2934H47.3878C46.5651 61.2934 45.7749 61.1306 45.0352 60.8029C42.8217 58.0731 41.1223 54.9111 40.0807 51.463C39.9987 50.6122 39.9561 49.7041 39.9561 48.7388C39.9561 40.3103 43.2841 36.1842 47.3878 36.1842H66.4863V34.2266H53.7757V28.0083C53.7757 24.8508 59.3968 22.2905 66.3303 22.2905C73.2637 22.2905 78.8838 24.8507 78.8838 28.0082Z",
    fill: "#3876AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2477 30.8382C60.5236 30.8382 61.5579 29.8039 61.5579 28.528C61.5579 27.2521 60.5236 26.2178 59.2477 26.2178C57.9718 26.2178 56.9375 27.2521 56.9375 28.528C56.9375 29.8039 57.9718 30.8382 59.2477 30.8382Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.9383 48.0145C92.9383 49.2805 92.8631 50.4501 92.7216 51.5221C92.7216 51.5232 92.7216 51.5232 92.7205 51.5244C91.8384 54.4184 90.4828 57.1462 88.7089 59.597V59.5981C87.7391 60.2457 86.6537 60.5679 85.5077 60.5679H66.4093V62.5265H79.1188V67.893C77.9919 68.4821 76.825 68.9915 75.6268 69.4173C74.6433 69.7673 73.6404 70.0604 72.6232 70.2951H72.6221C70.6251 70.7564 68.5475 71 66.4103 71C61.9486 71 57.736 69.9381 54.0106 68.0524V55.1791C54.0106 51.9857 56.6001 49.3962 59.7935 49.3962H73.6905C77.7078 49.3962 80.9639 46.14 80.9639 42.1228V35.46H85.5076C89.6113 35.4599 92.9383 39.5006 92.9383 48.0145Z",
    fill: "#F7CD00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.9578 68.2255C75.9578 68.6622 75.8366 69.0707 75.6267 69.4176C74.6432 69.7676 73.6403 70.0606 72.6231 70.2953H72.622C71.861 69.9182 71.3379 69.1325 71.3379 68.2255C71.3379 66.9494 72.3717 65.9155 73.6479 65.9155C74.924 65.9155 75.9578 66.9494 75.9578 68.2255Z",
    fill: "#F2F2F2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_362_872"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 55,
    fill: "white",
    transform: "translate(38.9102 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFetImg4);
export default __webpack_public_path__ + "static/media/fet-img (4).da0e3dc2d4ff92c3975d88249a0195ac.svg";
export { ForwardRef as ReactComponent };